module.exports = __webpack_public_path__ + "img/personal_data.bbba8c3c.svg";